module.exports = __webpack_public_path__ + "img/Flag_of_the_Netherlands.6e0a056a.svg";